<template>
  <div class="club-points-detail">
    <div class="club-points-detail__head">
      <div class="club-points-detail__head-title">
        {{ title }}
      </div>
      <info-block :tooltip-text="tooltip" />
    </div>

    <div class="club-points-detail__content">
      <f-sprite-icon
        class="club-points-detail__icon"
        :icon-link="iconLink"
      />
      <div :class="classes">
        {{ points | price }}
      </div>
    </div>

    <club-summary-burns
      v-if="pointsBurnsInt > 0"
      :points="pointsBurnsInt"
      :date="date"
    />
  </div>
</template>

<script>
import ClubSummaryBurns from '@/components/account/club-summary-burns.vue';
import PointsBuy from '@images/points-buy.multi.svg';
import PointsPrize from '@images/points-prize.multi.svg';
import InfoBlock from '@kit/info-block/info-block.vue';

export default {
  name: 'club-points-detail',

  components: {
    ClubSummaryBurns,
    InfoBlock,
  },

  icons: {
    PointsBuy,
    PointsPrize,
  },

  props: {
    isPromotion: {
      type: Boolean,
      required: true,
    },
    points: {
      type: Number,
      required: true,
    },
    pointsBurns: {
      type: [Number, String],
      default: 0,
    },
    date: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: "",
    }
  },

  computed: {
    title() {
      return this.isPromotion ? 'акционные' : 'за покупки';
    },
    iconLink() {
      return this.isPromotion ?
        this.$options.icons.PointsPrize.id : this.$options.icons.PointsBuy.id;
    },
    classes() {
      const mode = this.isPromotion ? '_promotion' : '_buy';
      const base = 'club-points-detail__points';

      return [base, base + mode];
    },
    pointsBurnsInt() {
      return parseInt(this.pointsBurns);
    },
  },
}
</script>

<style lang="scss">
  .club-points-detail {
    padding: 4px 10px 10px 10px;
    border: 1px solid rgba(26, 120, 187, .08);
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04),
                0 8px 24px rgba(0, 0, 0, .03),
                0 16px 32px rgba(0, 0, 0, .02);

    @include breakpoint("tablet") {
      padding: 5px 12px 12px 12px;
    }

    &__head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    &__points {
      font-size: 28px;
      font-weight: bold;

      &_buy {
        color: $turquoise_f;
      }

      &_promotion {
        color: $blue;
      }
    }

    &__head-title {
      font-size: 12px;
      color: $black;

      @include breakpoint("tablet") {
        font-size: 14px;
      }
    }

    svg.club-points-detail__icon {
      width: 30px;
      height: 30px;
    }

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }
  }
</style>